import { render, staticRenderFns } from "./newContentModal.vue?vue&type=template&id=5bdd7e10&scoped=true"
import script from "./newContentModal.vue?vue&type=script&lang=js"
export * from "./newContentModal.vue?vue&type=script&lang=js"
import style0 from "./newContentModal.vue?vue&type=style&index=0&id=5bdd7e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd7e10",
  null
  
)

export default component.exports